module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info"
  }, [_c('h4', {
    staticClass: "info__title",
    class: {
      info__title_confirmed: _vm.isConfirmed
    }
  }, [_vm._v(_vm._s(_vm.confirmedText))]), (!_vm.isConfirmed) ? _c('Message', [_vm._v(_vm._s(_vm.message))]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7b969739","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/profile/views/settings/components/info/Info.vue
// module id = 50ec0ac3d4292ce3267a
// module chunks = 0